import { Component, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { MatInput, MatFormField, MatLabel } from '@angular/material/input';
import { FieldType } from '@ngx-formly/core';

@Component({
    selector: 'formly-color-picker',
    standalone: true,
    template: `
        <mat-form-field class="w-full float-left" appearance="outline">
            <mat-label>{{to.label}}</mat-label>
            <input
                type="color"
                matInput
                [name]="field.key?.toString()"
                [value]="field.formControl.value"
                (ngModelChange)="colorSelection($event)"
                (blur)="colorSelection($event)"
                required
                />
        </mat-form-field>
 `,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MatFormField, MatLabel, MatInput]
})
export class ColorPickerCustomComponent extends FieldType implements OnInit {
    @ViewChild(MatInput) formFieldControl: MatInput;
    ngOnInit(): void {

    }

    colorSelection(event): any {
        this.field.model[this.field.key.toString()] = event.target.value;
        this.field.formControl.setValue(event.target.value);
    }
};
